import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { ISummaryItem } from '../../../models';
import { CardLayout } from '../../common';
import { SummaryItemLayout } from '../confirm-schedule';

export interface IAdminSurveyOverviewProps {
	surveyId: number;
	summaryItemsLoading: boolean;
	summaryItems?: ISummaryItem[];
}

export class AdminSurveyOverview extends React.PureComponent<IAdminSurveyOverviewProps> {
	public render() {
		const { summaryItems, summaryItemsLoading, surveyId } = this.props;
		return (
			<CardLayout loading={summaryItemsLoading} title={ContentConstants.SURVEY_ADMIN_ACTION_SURVEY_OVERVIEW}>
				{summaryItems && (
					<SummaryItemLayout
						id='SummarySection'
						surveyId={surveyId}
						headerText={ContentConstants.CONFIRMSCHEDULE_SUMMARY_HEADER}
						isSurveyAdmin={true}
						summaryItems={summaryItems}
					/>
				)}
			</CardLayout>
		);
	}
}
